import { Backdrop, CircularProgress } from '@mui/material';

export function LoadingApp() {
  return (
    <Backdrop
      id="LoadingApp"
      sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1, display: 'none' })}
      open
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
let count = 0;
function dispatch(action: 'show' | 'hide') {
  requestAnimationFrame(() => {
    const el = document.getElementById('LoadingApp');
    if (!el) return;
    el.style.display = action === 'show' ? 'flex' : 'none';
    window.dispatchEvent(new CustomEvent('loadingApp', { detail: { action } }));
  });
}

export const loader = {
  show() {
    count += 1;
    if (count === 1) dispatch('show');
  },
  hide() {
    count = Math.max(0, count - 1);
    if (count === 0) dispatch('hide');
  },
  reset() {
    count = 0;
    dispatch('hide');
  },
};
